export const clientsRatePlans: { [key: string]: number } = {
  '1k': 1000,
  '3k': 3000,
  '10k': 10000,
  '25k': 25000,
  '100k': 100000,
  unlim: 9999999,
};
